"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.Label = exports.Header = exports.Wrapper = void 0;
var React = __importStar(require("react"));
var rebass_1 = require("rebass");
var Wrapper = function (_a) {
  var sx = _a.sx,
    props = __rest(_a, ["sx"]);
  return React.createElement(rebass_1.Box, __assign({
    sx: __assign({
      my: 2,
      px: 3,
      py: "24px",
      boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.11)",
      borderRadius: 5
    }, sx)
  }, props));
};
exports.Wrapper = Wrapper;
var Header = function (props) {
  return React.createElement(rebass_1.Flex, __assign({
    sx: {
      cursor: "pointer",
      alignItems: "center",
      justifyContent: "space-between",
      svg: {
        stroke: "blue1"
      }
    }
  }, props));
};
exports.Header = Header;
var Label = function (props) {
  return React.createElement(rebass_1.Text, __assign({
    sx: {
      flex: 1,
      color: "blue1",
      fontWeight: "bold",
      fontSize: 4
    }
  }, props));
};
exports.Label = Label;
var IconWrapper = function (props) {
  return React.createElement(rebass_1.Box, __assign({
    sx: {
      width: 24,
      height: 24
    }
  }, props));
};
exports.IconWrapper = IconWrapper;